/** DRF validation failures can be arrays, field dictionaries or detail strings. */
export function siteSaveError(error: any, fallback: string): string {
  const data = error?.response?.data;
  const messages = (value: unknown): string[] => {
    if (typeof value === "string") return [value];
    if (Array.isArray(value)) return value.flatMap(messages);
    if (value && typeof value === "object") return Object.values(value).flatMap(messages);
    return [];
  };
  // Do not render an HTML error page returned by a proxy as a user message.
  if (!data || typeof data === "string") return fallback;
  return messages(data).join(" ") || fallback;
}
